import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const TableHeader = ({
  className,
  renderSorter,
  children,
  onClick,
}) => (
  <div
    className={cx('table-header', className)}
    role={'presentation'}
    onClick={onClick}
  >
    {children}
    {renderSorter()}
  </div>
)

TableHeader.propTypes = {
  className: PropTypes.string,
  renderSorter: PropTypes.func,
  children: PropTypes.any,
  onClick: PropTypes.func,
}
TableHeader.defaultProps = {
  className: '',
  renderSorter: () => {},
  children: null,
  onClick: () => {},
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/components/Table/tableElements/TableHeader.js